import { Button, buttonVariants, cn } from "@tellescope/ui";
import type { ButtonBlock as ButtonBlockType } from "../../../shared/schema";

interface ButtonBlockProps {
  text: ButtonBlockType["props"]["text"];
  variant: ButtonBlockType["props"]["variant"];
  href?: ButtonBlockType["props"]["href"];
}

export const ButtonBlock: React.FC<ButtonBlockProps> = ({ text, variant = "default", href }) => {
  if (!text) return null;

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cn(buttonVariants({ variant }))}>
        {text}
      </a>
    );
  }

  return <Button variant={variant}>{text}</Button>;
};
